import React, { useEffect, useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { useDispatch } from "react-redux";

import { useLazyQuery } from "@apollo/client";
import { Slider } from "@material-ui/core";

import * as categoryAction from "../../../app/NewRedux/Categories/categoryAction";
import * as actions from "../../../app/Pages/Dashboard/_redux/dashboardActions";
import EquipBidLogo from "../../../assets/images/equip_bid_logo.png";
import AttachmentIcon from "../../../assets/images/icons/attachment.svg";
import CloseButtonBlack from "../../../assets/images/icons/close.svg";
import EquipmentIcon from "../../../assets/images/icons/equipment.svg";
import EquipmentIconActive from "../../../assets/images/icons/equipment_tab_active.svg";
// import VehicleIconActive from "../../../assets/images/icons/vehicle_tab_active.svg";
// import TrailerIconActive from "../../../assets/images/icons/trailer_tab_active.svg";
// import AttachmentIconActive from "../../../assets/images/icons/attachment_tab_active.svg";
// import MaterialIconActive from "../../../assets/images/icons/material_tab_active.svg";
import GreenLocationPin from "../../../assets/images/icons/green_location_pin.svg";
import GridIcon from "../../../assets/images/icons/grid.svg";
import MaterialIcon from "../../../assets/images/icons/material.jpg";
import RedLocationPin from "../../../assets/images/icons/red_location_pin.svg";
import TrailerIcon from "../../../assets/images/icons/trailer.svg";
import VehicleIcon from "../../../assets/images/icons/truck.svg";
import { LIST_CATEGORIES_BY_LOCATION } from "../../NewQuery/Category/categoryQuery";
import ButtonV2 from "../ButtonV2";
import { HeaderLocationModal } from "../EquipBidHeaderLocationModal";
import "../../../styles/newStyles/headerModal.scss";

export default function EquipBidHeader({ setSelectedHeaderTab, filterSelectedData, setFilterSelectedData, setStepperState, showHeaderBottom }) {
  const dispatch = useDispatch();

  const [locationModalStatus, setShowLocationModal] = useState(false);

  const [getCategories,
    { loading: categoryLoading, error: categoryError, data: categoryData }] = useLazyQuery(LIST_CATEGORIES_BY_LOCATION, {
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    dispatch(actions.loading(categoryLoading));
    if (categoryData) {
      dispatch(categoryAction.list(categoryData.getAllAssetWithinRange));
    }
  }, [categoryLoading, categoryError, categoryData, dispatch]);

  const [locationFormData, setLocationFormData] = useState({
    country: ["India", "United State of America", "South Africa"],
    location: "",
    locationError: false,
    postalCode: "",
    postalCodeError: false,
    distance: "0",
    selectedCountry: "",
    selectedCountryError: false,
    areaData: "",
    latitude: "",
    longitude: "",
    locationDetailledObject: "",
  });

  const marks = [
    {
      value: 5,
      label: "50",
      data: "50",
    },
    {
      value: 10,
      label: "|",
      data: "100",
    },
    {
      value: 15,
      label: "150",
      data: "150",
    },
    {
      value: 20,
      label: "|",
      data: "200",
    },

    {
      value: 25,
      label: "250",
      data: "250",
    },
    {
      value: 30,
      label: "|",
      data: "300",
    },
    {
      value: 35,
      label: "350",
      data: "350",
    },
    {
      value: 40,
      label: "|",
      data: "400",
    },
    {
      value: 45,
      label: "450",
      data: "450",
    },
    {
      value: 50,
      label: "|",
      data: "500",
    },
    {
      value: 55,
      label: "550",
      data: "550",
    },
    {
      value: 60,
      label: "|",
      data: "600",
    },
    {
      value: 65,
      label: "650",
      data: "650",
    },
    {
      value: 70,
      label: "|",
      data: "700",
    },

    {
      value: 75,
      label: "750",
      data: "750",
    },
    {
      value: 80,
      label: "|",
      data: "800",
    },
    {
      value: 85,
      label: "850",
      data: "850",
    },
    {
      value: 90,
      label: "|",
      data: "900",
    },
    {
      value: 95,
      label: "Country",
      data: "Country",
    },
    {
      value: 100,
      label: "World",
      data: "World",
    },
  ];

  const toggleLocationModal = (e) => {
    let updatedStateObject = {
      latitude: "",
      longitude: "",
      locationDetailledObject: "",
    };
    navigator.geolocation.getCurrentPosition((position) => {
      const positionCoords = position.coords;

      if (!locationModalStatus) {
        updatedStateObject["latitude"] = positionCoords.latitude;
        updatedStateObject["longitude"] = positionCoords.longitude;
      }

      updateState(updatedStateObject);
      setShowLocationModal(!locationModalStatus);
    });
  };

  function valuetext(value) {
    return `${value}`;
  }

  function valueLabelFormat(value) {
    return marks.findIndex((mark) => mark.value === value) + 1;
  }

  const setCurrentLocation = () => {
    navigator.geolocation.getCurrentPosition((position) => {
      const positionCoords = position.coords;

      fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${positionCoords.latitude},${positionCoords.longitude}&key=AIzaSyBykGCg19skxwuA3wg4d-up_TLAjcH0OTI`,
      )
        .then((response) => response.json())
        .then((response) => {
          let locationData = response.results[0];
          let updatedStateObject = {
            location: locationData.address_components.filter((value) =>
              value.types.includes("administrative_area_level_3"),
            )[0].long_name,
            locationError: false,
            postalCode: locationData.address_components.filter((value) =>
              value.types.includes("postal_code"),
            )[0].long_name,
            postalCodeError: false,
            selectedCountry: locationData.address_components.filter((value) =>
              value.types.includes("country"),
            )[0].long_name,
            selectedCountryError: false,
            latitude: positionCoords.latitude,
            longitude: positionCoords.longitude,
            locationDetailledObject: response,
          };
          updateState(updatedStateObject);
        });
    });
  };

  const handleInputChange = (event) => {
    let { name, value } = event.target;
    let updatedStateObject = {
      [name]: value,
      [name + "Error"]: false,
    };
    updateState(updatedStateObject);
  };

  const handleDistanceChange = (event, newValue) => {
    let selectedLocationDistanceValue = marks.filter(
      (mark) => mark.value === newValue,
    )[0].data;
    let updatedStateObject = {
      distance: selectedLocationDistanceValue,
    };
    updateState(updatedStateObject);
  };

  const handleLocationModalSubmit = () => {
    let updatedStateObject = {
      location: "",
      locationError: false,
      postalCode: "",
      postalCodeError: false,
      distance: "0",
      selectedCountry: "",
      selectedCountryError: false,
      latitude: "",
      longitude: "",
      locationDetailledObject: "",
    };
    if (
      locationFormData.selectedCountry &&
      locationFormData.postalCode &&
      locationFormData.location
    ) {
      updatedStateObject = {
        areaData:
          locationFormData?.locationDetailledObject?.plus_code?.compound_code ||
          locationFormData.location + ", " + locationFormData.selectedCountry,
      };
      getCategories({
        variables: {
          latitude: locationFormData.latitude,
          longitude: locationFormData.longitude,
          distance: +locationFormData.distance,
        },
      });
      toggleLocationModal();
      resetAllState();
    } else {
      updatedStateObject = {
        locationError: locationFormData.location ? false : true,
        postalCodeError: locationFormData.postalCode ? false : true,
        selectedCountryError: locationFormData.selectedCountry ? false : true,
      };
    }

    updateState(updatedStateObject);
  };

  const resetAllState = () => {
    setLocationFormData({
      country: ["India", "United State of America", "South Africa"],
      location: "",
      locationError: false,
      postalCode: "",
      postalCodeError: false,
      distance: "",
      selectedCountry: "",
      selectedCountryError: false,
      areaData: "",
      latitude: "",
      longitude: "",
      locationDetailledObject: "",
    });
  };

  const updateState = (updatedStateObject) => {
    setLocationFormData((preVal) => ({
      ...preVal,
      ...updatedStateObject,
    }));
  };

  let modalBody = (
    <Form>
      <Form.Group className="mb-3" controlId="formBasicEmail">
        <Form.Label>Country</Form.Label>
        <div>
          <select
            className="form-control"
            name="selectedCountry"
            onChange={handleInputChange}
          >
            <option defaultValue={""}>Select</option>
            {locationFormData.country.map((countryValue, index) => {
              return (
                <option
                  defaultValue={countryValue}
                  key={`country${index}`}
                  selected={
                    countryValue === locationFormData.selectedCountry
                      ? true
                      : false
                  }
                >
                  {countryValue}
                </option>
              );
            })}
          </select>
        </div>
        {locationFormData.selectedCountryError ? (
          <font color="red">Country field is mandatory</font>
        ) : null}
      </Form.Group>
      <Form.Group className="mb-3" controlId="formBasicPassword">
        <Form.Label>Location</Form.Label>
        <Row>
          <Col className="col-8">
            <Form.Control
              type="text"
              placeholder="location"
              name="location"
              onChange={handleInputChange}
              value={locationFormData.location}
            />
          </Col>
          <Col className="col-4">
            <button
              type="button"
              className="currentLocationBtn"
              onClick={setCurrentLocation}
            >
              Current Location
            </button>
          </Col>
        </Row>
        {locationFormData.locationError ? (
          <font color="red">Location field is mandatory</font>
        ) : null}
      </Form.Group>
      <Form.Group className="mb-3" controlId="formBasicPassword">
        <Form.Label>Zip/ Postal Code</Form.Label>
        <Form.Control
          type="text"
          placeholder="Enter your zipcode"
          name="postalCode"
          onChange={handleInputChange}
          value={locationFormData.postalCode}
        />
        {locationFormData.postalCodeError ? (
          <font color="red">Postal Code field is mandatory</font>
        ) : null}
      </Form.Group>

      <Form.Group className="mb-3" controlId="formBasicPassword">
        <Form.Label>Distance (mi)</Form.Label>
        <Slider
          defaultValue={0}
          valueLabelFormat={valueLabelFormat}
          getAriaValueText={valuetext}
          aria-labelledby="discrete-slider-restrict"
          step={null}
          valueLabelDisplay="off"
          marks={marks}
          onChange={handleDistanceChange}
        />
      </Form.Group>
    </Form>
  );

  let modalFooter = (
    <>
      <button
        className="cancelBtn locationModalFooterBtn"
        onClick={() => {
          toggleLocationModal();
          resetAllState();
        }}
      >
        Cancel
      </button>
      <button
        className="submitBtn locationModalFooterBtn"
        onClick={handleLocationModalSubmit}
      >
        Submit
      </button>
    </>
  );
  const tabSelection = (tabValue) => {
    if (tabValue !== filterSelectedData.tabs[0]) {
      setFilterSelectedData({ tabs: [tabValue], category: [], makes: [], models: [] });
      setSelectedHeaderTab(tabValue);
      setStepperState(0);
    }
  };

  const redirectToHomePage = () => {
    setSelectedHeaderTab("");
    setFilterSelectedData({
      tabs: [],
      category: [],
      makes: [],
      models: [],
    });
    setStepperState(0);
  };

  const clearAllTabFilters = (value) => {

    let tabs = filterSelectedData.tabs.findIndex((filterValue) => filterValue === value);
    let category = filterSelectedData.category.findIndex((filterValue) => filterValue.id === value);
    let makes = filterSelectedData.makes.findIndex((filterValue) => filterValue.id === value);
    switch (true) {
    case (tabs !== -1 && category === -1 && makes === -1): {
      setFilterSelectedData({
        tabs: [],
        category: [],
        makes: [],
        models: [],
      });
      setSelectedHeaderTab("");
      setStepperState(0);
      break;
    }

    case (tabs === -1 && category !== -1 && makes === -1): {
      setFilterSelectedData((preVal) => ({
        ...preVal,
        category: [],
        makes: [],
        models: [],
      }));
      setStepperState(0);
      break;
    }

    default: {
      let makesFilteredData = filterSelectedData.makes.filter((preValue) => value !== preValue.id);
      setFilterSelectedData((preVal) => ({
        ...preVal,
        makes: [...makesFilteredData],
        models: [],
      }));
      setStepperState(1);
    }
    }
  };

  return (
    <>
      <div id="equipbid-header">
        <div className="upper-header">
          <img src={EquipBidLogo} onClick={() => redirectToHomePage()} />

          <div className="search-box d-flex align-items-center ">
            <input className="search-input" placeholder="Search" />
            <div className="d-flex location-pin">
              <img
                src={
                  !locationFormData.areaData ? RedLocationPin : GreenLocationPin
                }
                alt="location_pin"
                className=" px-3"
                onClick={toggleLocationModal}
              />
              <span className="ml-3" onClick={toggleLocationModal}>
                {locationFormData.areaData}
              </span>
            </div>
          </div>

          <div className="d-flex align-items-center">
            <a className="sign-in-link mr-7">Sign In</a>
            <ButtonV2 btnName="Sign Up" btnOnClick={() => { }} />
          </div>
        </div>
        {
          showHeaderBottom ? <div className="header-bottom">
            <div onClick={() => { tabSelection("Equipment"); }}>
              <img src={filterSelectedData.tabs.includes("Equipment") ? EquipmentIconActive : EquipmentIcon} />
              <span className={`${filterSelectedData.tabs.includes("Equipment") ? "activeTabText" : ""} tabText`}>Equipment</span>
            </div>
            <div onClick={() => { tabSelection("Vehicles"); }}>
              <img src={VehicleIcon} />
              <span className={`${filterSelectedData.tabs.includes("Vehicles") ? "activeTabText" : ""}  tabText`}>Vehicles</span>
            </div>
            <div onClick={() => { tabSelection("Trailer"); }}>
              <img src={TrailerIcon} />
              <span className={`${filterSelectedData.tabs.includes("Trailer") ? "activeTabText" : ""}  tabText`}>Trailer</span>
            </div>
            <div onClick={() => { tabSelection("Attachment"); }}>
              <img src={AttachmentIcon} />
              <span className={`${filterSelectedData.tabs.includes("Attachment") ? "activeTabText" : ""}  tabText`}>Attachment</span>
            </div>
            <div onClick={() => { tabSelection("Building"); }}>
              <img src={MaterialIcon} />
              <span className={`${filterSelectedData.tabs.includes("Building") ? "activeTabText" : ""}  tabText`}>Building Material</span>
            </div>
            <div onClick={() => { tabSelection("Other"); }}>
              <img src={GridIcon} />
              <span className={`${filterSelectedData.tabs.includes("Other") ? "activeTabText" : ""}  tabText`}>Other</span>
            </div>
          </div> : null
        }

        <HeaderLocationModal
          modalStatus={locationModalStatus}
          setModalStatus={() => {
            toggleLocationModal();
            resetAllState();
          }}
          heading={"Distance"}
          modalBody={modalBody}
          modalFooter={modalFooter}
        />
      </div>
      {
        filterSelectedData.tabs.length ? <div className="equipment-filter">
          {filterSelectedData.tabs.length ? filterSelectedData.tabs.map((value, index) => (<span className="filter-pill" key={index}>{value} <img src={CloseButtonBlack} className="filterPillCloseButton" onClick={() => { clearAllTabFilters(value); }} /></span>
          )) : null}
          {(filterSelectedData.tabs.length && filterSelectedData.category.length) ? filterSelectedData.category.map((value, index) => (<span className="filter-pill" key={index}>{value.name} <img src={CloseButtonBlack} className="filterPillCloseButton" onClick={() => { clearAllTabFilters(value.id); }} /></span>
          )) : null}
          {(filterSelectedData.tabs.length && filterSelectedData.category.length && filterSelectedData.makes.length && !filterSelectedData.models.length) ? filterSelectedData.makes.map((value, index) => (<span className="filter-pill" key={index}>{value.name} <img src={CloseButtonBlack} className="filterPillCloseButton" onClick={() => { clearAllTabFilters(value.id); }} /></span>
          )) : null}
          {(filterSelectedData.tabs.length && filterSelectedData.category.length && filterSelectedData.makes.length && filterSelectedData.models.length) ? filterSelectedData.models.map((value, index) => (<span className="filter-pill" key={index}>{value.name} <img src={CloseButtonBlack} className="filterPillCloseButton" onClick={() => { clearAllTabFilters(value.id); }} /></span>
          )) : null}
        </div> : null
      }
    </>
  );
}
